import { render, staticRenderFns } from "./ConservancyFees.vue?vue&type=template&id=0a4f9ec3&scoped=true"
import script from "./ConservancyFees.vue?vue&type=script&lang=js"
export * from "./ConservancyFees.vue?vue&type=script&lang=js"
import style0 from "./ConservancyFees.vue?vue&type=style&index=0&id=0a4f9ec3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4f9ec3",
  null
  
)

export default component.exports